import { ResponseUnlockUserService, UserType } from "../types";
import axiosInstance from "../config/axiosIntance";

type UnlockServiceParams = {
  userName?: string;
  serviceProvider: string;
  currentUser: UserType;
};

export const unlockUserService = async ({
  userName,
  serviceProvider,
  currentUser
}: UnlockServiceParams): Promise<ResponseUnlockUserService> => {
  const responseFetched = await axiosInstance.post(
    `/account/unlockUser`,
    {
      userName,
      serviceProvider
    },
    {
      headers: {
        Authorization: `Bearer ${currentUser.token}`
      }
    }
  );

  const { data } = responseFetched.data;

  return data;
};
